export const PRODUCT_IMPORT_DEMO_FAILURES = [
  {
    key: 'row-2-barcode',
    row: 2,
    type: 'ซ้ำ',
    field: 'บาร์โค้ด',
    issue: 'ซ้ำกับแถวที่ 7 ในไฟล์เดียวกัน',
  },
  {
    key: 'row-4-name-th',
    row: 4,
    type: 'ว่าง',
    field: 'ชื่อสินค้าภาษาไทย',
    issue: 'ฟิลด์บังคับ ห้ามเว้นว่าง',
  },
  {
    key: 'row-6-width',
    row: 6,
    type: 'รูปแบบ',
    field: 'ความกว้าง',
    issue: 'ต้องเป็นตัวเลขเท่านั้น',
  },
  {
    key: 'row-9-expire',
    row: 9,
    type: 'รูปแบบ',
    field: 'วันหมดอายุ',
    issue: 'วันที่อยู่ในอดีต (03 ม.ค. 2568)',
  },
  {
    key: 'row-11-category',
    row: 11,
    type: 'ว่าง',
    field: 'หมวดหมู่สินค้า',
    issue: 'ฟิลด์บังคับ ห้ามเว้นว่าง',
  },
  {
    key: 'row-13-sku',
    row: 13,
    type: 'ซ้ำ',
    field: 'รหัสสินค้า',
    issue: 'ซ้ำกับสินค้าที่มีอยู่ในระบบ',
  },
  {
    key: 'row-15-weight',
    row: 15,
    type: 'รูปแบบ',
    field: 'น้ำหนัก',
    issue: 'ต้องเป็นตัวเลขมากกว่า 0',
  },
  {
    key: 'row-17-name-en',
    row: 17,
    type: 'ว่าง',
    field: 'ชื่อสินค้าภาษาอังกฤษ',
    issue: 'ฟิลด์บังคับ ห้ามเว้นว่าง',
  },
  {
    key: 'row-19-lot',
    row: 19,
    type: 'ว่าง',
    field: 'ล็อตสินค้า',
    issue: 'ฟิลด์บังคับ ห้ามเว้นว่าง',
  },
  {
    key: 'row-21-height',
    row: 21,
    type: 'รูปแบบ',
    field: 'ความสูง',
    issue: 'ต้องเป็นตัวเลขเท่านั้น',
  },
  {
    key: 'row-23-length',
    row: 23,
    type: 'รูปแบบ',
    field: 'ความยาว',
    issue: 'ค่าต้องไม่เกิน 200 เซนติเมตร',
  },
  {
    key: 'row-25-detail',
    row: 25,
    type: 'ว่าง',
    field: 'รายละเอียดสินค้า',
    issue: 'ฟิลด์บังคับ ห้ามเว้นว่าง',
  },
];

export function createDemoProductImportFile() {
  return new File(['demo'], 'product-import-sample.csv', {
    type: 'text/csv',
  });
}
